import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { companyInfo } from '../../data/content';
import Button from '../ui/Button';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Emergency', path: '/emergency' },
    { name: 'Service Areas', path: '/areas' },
    { name: 'About', path: '/about' },
    { name: 'Financing', path: '/financing' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      {/* Emergency Banner */}
      <div className="bg-accent text-white py-2 px-4 text-center text-sm font-semibold flex items-center justify-center gap-2">
        <SafeIcon name="AlertTriangle" />
        24/7 EMERGENCY SERVICE ACROSS MONTREAL: <a href="tel:5145550148" className="underline">{companyInfo.phone}</a>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-2">
            <SafeIcon name="Droplet" className="text-3xl text-primary" />
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-primary leading-none">BlueFlow</span>
              <span className="text-xs font-semibold text-secondary tracking-widest uppercase">Plumbing & Drain</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-6 items-center">
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-secondary ${location.pathname === link.path ? 'text-primary border-b-2 border-primary' : 'text-text'}`}
              >
                {link.name}
              </Link>
            ))}
            <Button to="/request-service" variant="primary" className="ml-4 px-4 py-2 text-sm">
              Book Service
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-text" onClick={() => setIsOpen(!isOpen)}>
            <SafeIcon name={isOpen ? "X" : "Menu"} className="text-2xl" />
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 pt-2 pb-4 space-y-1 shadow-lg absolute w-full">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className="block px-3 py-2 text-base font-medium text-text hover:text-primary hover:bg-gray-50 rounded-md"
              onClick={() => setIsOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <Button to="/request-service" variant="primary" className="w-full mt-4 justify-center" onClick={() => setIsOpen(false)}>
            Book Service Now
          </Button>
        </div>
      )}
    </header>
  );
}